










































































































import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "Forbidden",
})
export default class Error extends Vue {
  public back() {
    history.back();
  }
}
